import { HabitSchedule, Timestamp } from '@griply/types';
import { isBefore, startOfDay } from 'date-fns';

import { getActualScheduleStartDate } from './get-actual-schedule-start-date';
import { getScheduleEndDate } from './get-schedule-end-date';

export const getActiveSchedule = (
  schedules: HabitSchedule[] | undefined | null,
  today: Timestamp,
) => {
  if (!schedules?.length) {
    return undefined;
  }

  const todayStart = startOfDay(today);

  // Single schedule is always active, unless it has expired
  if (schedules.length === 1) {
    const schedule = schedules[0];
    const scheduleEnd = getScheduleEndDate(schedule);
    return scheduleEnd && isBefore(scheduleEnd, todayStart)
      ? undefined
      : schedule;
  }

  // endDate is exclusive: getScheduleEndDate is the last active day (endDate - 1)
  const nonExpired = schedules.filter((schedule) => {
    const scheduleEnd = getScheduleEndDate(schedule);
    return !scheduleEnd || !isBefore(scheduleEnd, todayStart);
  });

  if (!nonExpired.length) {
    return undefined;
  }

  // Prefer the most recently started schedule
  const started = nonExpired
    .filter(
      (schedule) => !isBefore(todayStart, getActualScheduleStartDate(schedule)),
    )
    .sort(
      (scheduleA, scheduleB) =>
        scheduleB.startDate.getTime() - scheduleA.startDate.getTime(),
    );

  if (started.length) {
    return started[0];
  }

  // No started schedule, fall back to the nearest upcoming one
  return nonExpired.sort(
    (scheduleA, scheduleB) =>
      scheduleA.startDate.getTime() - scheduleB.startDate.getTime(),
  )[0];
};
